import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Login} from '../../../modelo/usuario/login';
import {SubscriptionLike} from 'rxjs';
import {Producto} from '../../../modelo/producto/producto';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {UserloginService} from '../../../servicios/usuario/userlogin.service';
import {ActivatedRoute} from '@angular/router';
import {ProductoService} from '../../../servicios/producto/producto.service';

@Component({
  selector: 'app-productos-ofertas',
  templateUrl: './productos-ofertas.component.html',
  styleUrls: ['./productos-ofertas.component.css']
})
export class ProductosOfertasComponent implements OnInit, OnDestroy {
  public currentUser: Login;
  private subs: SubscriptionLike[];
  public productos: Producto[];

  public paginaActual = 0;
  public cantXPagina = 50;
  public cantidadPaginas = 0;
  public totalItems:number;
  public idUsuario:number=0;
  pageEvent: PageEvent;
  public clicodigo: string;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(private userLogin: UserloginService, private routerAc: ActivatedRoute, private prodSV: ProductoService) {
    this.currentUser = null;
    this.subs = [];
    this.productos = [];
    this.pageEvent = new PageEvent();

  }

  ngOnInit(): void {
    this.subs.push(
      this.userLogin.currentUser.subscribe(res => {
        this.currentUser = res;
        this.clicodigo = this.currentUser != null ? this.currentUser.cliCodigo : '0';
        this.idUsuario = this.currentUser != null ? parseInt(this.currentUser.idUsuario) : 0;
        if (this.currentUser != null) {
          this.paginator._intl.itemsPerPageLabel = 'Productos por pagina: ';
          this.paginator._intl.firstPageLabel = 'Primera página';
          this.paginator._intl.lastPageLabel = 'Ultima página';
          this.paginator._intl.nextPageLabel = 'Página siguiente';
          this.paginator._intl.previousPageLabel = 'Página anterior';
          this.subs.push(
            this.prodSV.traerOfertas(this.clicodigo, this.paginaActual, this.cantXPagina).subscribe(res => {
                this.productos = res.data.productos;
                this.totalItems = res.data.totalItems;
                this.cantidadPaginas = res.data.cantPaginas;
              }
            ));
        }
      }));
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  getServerData($event: PageEvent) {
    this.cantidadPaginas = $event.pageSize;
    this.subs.push(
      this.prodSV.traerOfertas(this.clicodigo, $event.pageIndex, $event.pageSize).subscribe(res => {
          this.productos = res.data.productos;
        }
      ));
    return $event;
  }

}
